module.exports = __webpack_public_path__ + "static/media/QuickSwap_logo.420e2e01.png";